import { IProductoServicio } from "@/shared/interfaces/erp/administration/producto_servicio.interface"
import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"

export const useTableColumnsProductoServicio = () => {


  const columnBase = useMemo<MRT_ColumnDef<IProductoServicio>[]>(() => [
    {
      accessorKey: 'codigo',
      header: 'codigo',
      size: 200,
    },
    {
      accessorKey: 'nombre',
      header: 'nombre',
      size: 200,
    },
  ], [])


  return {
    columnBase
  }
}